import { render, staticRenderFns } from "./SafeDigContactUs.vue?vue&type=template&id=216a7344&scoped=true"
import script from "./SafeDigContactUs.vue?vue&type=script&lang=js"
export * from "./SafeDigContactUs.vue?vue&type=script&lang=js"
import style0 from "./SafeDigContactUs.vue?vue&type=style&index=0&id=216a7344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216a7344",
  null
  
)

export default component.exports